import axiosSetup from "../utils/axiosSetup";

export type RefurbishedStockStatus = "needs_repair" | "refurbished";

export interface RefurbishedStockQuery {
  page: number;
  limit: number;
  search?: string;
  status?: RefurbishedStockStatus;
  warehouseId?: string;
  productId?: string;
  dispatched?: "true" | "false";
  receivedFrom?: string;
  receivedTo?: string;
}

export interface StockDisplayReference {
  _id?: string;
  name?: string;
  productName?: string;
  username?: string;
  fullName?: string;
  orderNumber?: string;
}

export type StockReference = string | StockDisplayReference | null;

export interface RefurbishedStockHistoryItem {
  action?: string;
  previousStatus?: string;
  oldStatus?: string;
  fromStatus?: string;
  newStatus?: string;
  toStatus?: string;
  status?: string;
  date?: string;
  createdAt?: string;
  timestamp?: string;
  performedAt?: string;
  actor?: StockReference;
  performedBy?: StockReference;
  user?: StockReference;
  userId?: StockReference;
  createdBy?: StockReference;
  warehouse?: StockReference;
  warehouseId?: StockReference;
  relatedSerial?: string;
  relatedSerialNumber?: string;
  serialNumber?: string;
  replacementSerialNumber?: string;
  relatedOrder?: StockReference;
  relatedOrderId?: StockReference;
  orderId?: StockReference;
  order?: StockReference;
  orderNumber?: string;
  reason?: string;
}

export interface RefurbishedStockRecord {
  _id: string;
  serialNumber: string;
  replacementSerialNumber?: string;
  product?: StockReference;
  productId?: StockReference;
  warehouse?: StockReference;
  warehouseId?: StockReference;
  status: RefurbishedStockStatus;
  dispatchedDate?: string | null;
  reason?: string;
  receivedDate?: string;
  refurbishedDate?: string;
  refurbishedBy?: StockReference;
  repairedDate?: string;
  repairedBy?: StockReference;
  repairedAt?: string;
  history?: RefurbishedStockHistoryItem[];
}

export interface RefurbishedStockResponse {
  data: RefurbishedStockRecord[];
  pagination: {
    totalPages: number;
    totalCount: number;
    page: number;
    limit: number;
  };
}

export const fetchRefurbishedStockApi = async (
  query: RefurbishedStockQuery,
): Promise<RefurbishedStockResponse> => {
  const response = await axiosSetup.get("/dispatch/refurbished-stock", {
    params: query,
  });
  return response.data;
};

export const markStockRefurbishedApi = async (serialNumber: string) => {
  const response = await axiosSetup.patch(
    `/dispatch/refurbished-stock/${encodeURIComponent(serialNumber)}/mark-refurbished`,
  );
  return response.data;
};
